const toFiniteNumber = (value, fallback) => {
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : fallback;
};

export const DEFAULT_FLOATING_MENU_TRIGGER_DEDUPE_MS = 250;

export const createFloatingMenuTriggerRecord = ({
  source,
  now = Date.now(),
} = {}) => ({
  source,
  occurredAtMs: toFiniteNumber(now, Date.now()),
});

export const shouldIgnoreDuplicateFloatingMenuTrigger = ({
  source,
  lastHandledTrigger,
  now = Date.now(),
  dedupeWindowMs = DEFAULT_FLOATING_MENU_TRIGGER_DEDUPE_MS,
} = {}) => {
  if (!source) return false;
  if (!lastHandledTrigger?.source) return false;
  if (lastHandledTrigger.source === source) return false;

  const currentTime = toFiniteNumber(now, Date.now());
  const previousTime = toFiniteNumber(lastHandledTrigger.occurredAtMs, null);
  if (previousTime === null) return false;

  const elapsedMs = currentTime - previousTime;
  if (elapsedMs < 0) return false;

  const normalizedWindow = Math.max(
    0,
    toFiniteNumber(dedupeWindowMs, DEFAULT_FLOATING_MENU_TRIGGER_DEDUPE_MS)
  );
  return elapsedMs <= normalizedWindow;
};
